import Language from '@/contexts/language/locales/en';

export default {
  mixins: [Language],
  methods: {
    getElementString(labelId = '', props = '') {
      let html = this.getText(labelId, props);
      let div = document.createElement("div");
      div.innerHTML = html;
      return div.innerText
    },
  }
}
